export enum ResultFilter {
  All = "All",
  Fail = "Fail",
  Pass = "Pass",
  Merit = "Merit",
  Distinction = "Distinction",
}

export enum AttemptStatus {
  All = "All",
  NotStarted = "Not Started",
  InProgress = "In Progress",
  Submitted = "Submitted ",
  Draft = "Draft",
}

export enum QuestionType {
  Multiple = "Single/Multiple choice",
  Paragraph = "Paragraph",
  CaseStudy = "Case Study",
}

export enum StatusPracticeTest {
  draft = "draft",
}

export enum Role {
  ADMIN = "admin",
  TUTOR = "tutor",
  STUDENT = "student",
}

export enum ClassStatus {
  ACTIVE = "active",
  DEACTIVATED = "deactivated",
}

export enum YEAR_SORT_OPTIONS {
  ASC = "asc",
  DESC = "desc",
  DEFAULT = "default",
}

export enum LoginType {
  MOODLE = "MOODLE",
  MANUAL = "MANUAL",
}

export enum TypeFilterLabel {
  non_case_study = "All",
  text = "Standard",
  choice = "Multiple Choice",
}
